export const dateWithComma = (dateString: string): string => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return dateString;
  }

  return `${date.toLocaleDateString("en-US", { month: "short" })} ${date.getDate()}, ${date.getFullYear()}`;
};

export const dateWithSlashes = (dateString: string) => {
  const date = new Date(dateString);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

export const formatNoTimeDate = (dateString: string) => {
  return new Date(`${dateString}T00:00:00`).toLocaleDateString();
};

export const dateStringToIsoDate = (
  dateString?: string | null,
): string | undefined => {
  if (!dateString) {
    return undefined;
  }

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return undefined;
  }

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${date.getFullYear()}-${month}-${day}T00:00:00Z`;
};
